const baseRequestState = {
  loading: false,
  success: false,
  failed: false,
};

export default baseRequestState;
